import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { MODULE_DATA } from '../../constants/navigation';
import { useAuthStore } from '../../stores/auth.store';

function NavigateToSelectedModule() {
    const { isLoggedIn } = useAuthStore();
    const { search } = window.location;
    const searchParams = new URLSearchParams(search);
    const [target, setTarget] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (searchParams.has('redirectUrl')) {
            setTarget(searchParams.get('redirectUrl') ?? '/dashboard');
            return;
        }
        const module = localStorage.getItem('selectedModule');
        if (module && MODULE_DATA[module]) {
            setTarget(MODULE_DATA[module].link);
        } else {
            setTarget('/dashboard');
        }
    }, [searchParams]);

    if (!isLoggedIn) {
        return <Navigate to="/auth/login" />;
    }
    if (target === undefined) {
        return null;
    }
    return <Navigate to={target} />;
}

export default NavigateToSelectedModule;
